export const countrySlugs = {
    BE: 'belgique',
    FR: 'France',
    GB: 'United Kingdom',
    AR: 'Argentina',
    IE: 'Ireland',
};
